var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarContactus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7410_531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.22179 0C4.62402 0 0.895996 3.58214 0.895996 8C0.895996 12.4179 4.62402 16 9.22179 16C13.8196 16 17.5476 12.4179 17.5476 8C17.5476 3.58214 13.8196 0 9.22179 0ZM9.22179 14.6429C5.40456 14.6429 2.30841 11.6679 2.30841 8C2.30841 4.33214 5.40456 1.35714 9.22179 1.35714C13.039 1.35714 16.1352 4.33214 16.1352 8C16.1352 11.6679 13.039 14.6429 9.22179 14.6429Z",
    fill: "black",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2958 4.51292C10.7383 4.04328 10.0023 3.78613 9.22179 3.78613C8.44125 3.78613 7.7053 4.04506 7.14777 4.51292C6.56794 5.00042 6.24829 5.65578 6.24829 6.35756V6.49328C6.24829 6.57185 6.31519 6.63613 6.39697 6.63613H7.28902C7.37079 6.63613 7.43769 6.57185 7.43769 6.49328V6.35756C7.43769 5.57006 8.23868 4.92899 9.22179 4.92899C10.2049 4.92899 11.0059 5.57006 11.0059 6.35756C11.0059 6.91292 10.597 7.42185 9.9633 7.65578C9.56932 7.80042 9.2348 8.05399 8.99506 8.38613C8.7516 8.72542 8.62523 9.13256 8.62523 9.54506V9.92899C8.62523 10.0076 8.69213 10.0718 8.77391 10.0718H9.66595C9.74773 10.0718 9.81463 10.0076 9.81463 9.92899V9.52363C9.81559 9.35028 9.8709 9.18122 9.97333 9.03852C10.0758 8.89581 10.2206 8.78608 10.3889 8.72363C11.4854 8.31828 12.1934 7.3897 12.1934 6.35756C12.1953 5.65578 11.8756 5.00042 11.2958 4.51292ZM8.47841 11.929C8.47841 12.1184 8.55673 12.3001 8.69614 12.4341C8.83555 12.568 9.02463 12.6433 9.22179 12.6433C9.41894 12.6433 9.60802 12.568 9.74743 12.4341C9.88684 12.3001 9.96516 12.1184 9.96516 11.929C9.96516 11.7396 9.88684 11.5579 9.74743 11.4239C9.60802 11.29 9.41894 11.2147 9.22179 11.2147C9.02463 11.2147 8.83555 11.29 8.69614 11.4239C8.55673 11.5579 8.47841 11.7396 8.47841 11.929Z",
    fill: "black",
    fillOpacity: 0.65
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7410_531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6516,
    height: 16,
    fill: "white",
    transform: "translate(0.895996)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarContactus);
export default __webpack_public_path__ + "static/media/sidebar-contactus.b140d401cfc0045f1ba68ad5976e84f5.svg";
export { ForwardRef as ReactComponent };